import api from 'api/axiosInstance';
import type { ISwanOnboarding } from 'types/onboarding.types';

const getOngoingOnboarding = (): Promise<{
  hasOngoingOnboarding: boolean;
  onboarding?: ISwanOnboarding;
}> => api.get('/v2/accountable-banking/onboarding/ongoing');

export default getOngoingOnboarding;
